
import api from 'vf-react/lib/api';


export function checkAuth(username, password, pin) {
    const params = {
        username,
        password,
        type: 'partner'
    };

    if (pin) {
        params.challenge = pin;
    }

    // Unauthenticated session tokens are only valid for 1 hour so request one
    // before logging in
    // Ideally when attempting to log in without an auth-token the API would
    // return "missing-auth-token-login" but it returns "invalid-credentials"
    api.v1.reset();
    return api.v1.post('auth/login', params);
}


export function requestPasswordReminder(username) {
    return api.v1.post('partners/password/reset', { username });
}


export function resetPassword(new_password, reset_token, pin) {
    const params = {
        'new_password': new_password,
        'reset_token': reset_token,
    };

    if (pin) {
        params.challenge = pin;
    }

    return api.v1.post('partners/password/set', params);
}


export function checkActiveUser() {
    return new Promise((resolve, reject) => {
        api.v1.get('auth/status', 'json')
            .then(data => {
                if (data.type === 'anonymous') {
                    reject();
                } else {
                    resolve({
                        partnerId: data['partner_id'],
                        userId: data['id'],
                    });
                }
            })
            .catch(reject);
    });
}


export function logoutUser() {
    return new Promise((resolve, reject) => {
        api.v1.post('auth/logout')
            .then(() => {
                api.v1.reset();
                api.v1.init().finally(() => resolve());
            })
            .catch(reject);
    });
}
